import React from 'react';
import { Link } from 'react-router-dom';

export const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer 
      className="mt-12 border-t border-border bg-card/50 backdrop-blur-sm"
      role="contentinfo"
      aria-label="Site footer"
    >
      <div className="max-w-4xl mx-auto px-6 py-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* About Section */}
          <div className="space-y-3">
            <h2 className="text-sm font-semibold uppercase tracking-wider text-foreground">
              About raceqube
            </h2>
            <p className="text-sm text-muted-foreground leading-relaxed">
              A fantasy sports platform for auto sports racing. Operated as a personal hobby project 
              for entertainment purposes only.
            </p>
          </div>

          {/* Legal Links */}
          <div className="space-y-3">
            <h2 className="text-sm font-semibold uppercase tracking-wider text-foreground">
              Legal
            </h2>
            <nav aria-label="Legal links">
              <ul className="space-y-2">
                <li>
                  <Link 
                    to="/terms" 
                    className="text-sm text-muted-foreground hover:text-primary transition-colors inline-flex items-center"
                  >
                    Terms of Service
                  </Link>
                </li>
                <li>
                  <Link 
                    to="/privacy" 
                    className="text-sm text-muted-foreground hover:text-primary transition-colors inline-flex items-center"
                  >
                    Privacy Policy
                  </Link>
                </li>
              </ul>
            </nav>
          </div>

          {/* Contact Section */}
          <div className="space-y-3">
            <h2 className="text-sm font-semibold uppercase tracking-wider text-foreground">
              Support
            </h2>
            <nav aria-label="Support links">
              <ul className="space-y-2">
                <li>
                  <Link 
                    to="/contact" 
                    className="text-sm text-muted-foreground hover:text-primary transition-colors inline-flex items-center"
                  >
                    Contact Us
                  </Link>
                </li>
                <li>
                  <a 
                    href="mailto:support@raceqube.com" 
                    className="text-sm text-muted-foreground hover:text-primary transition-colors inline-flex items-center"
                  >
                    support@raceqube.com
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-8 pt-6 border-t border-border">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-xs text-muted-foreground text-center md:text-left">
              © {currentYear} raceqube. All rights reserved.
            </p>
            <p className="text-xs text-muted-foreground text-center md:text-right">
              Not affiliated with Formula 1, F1, or FIA.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};
